import React from 'react';

import {
  Hero,
  Life,
  Achieve,
  CurveBackground,
  CurrentOpenings,
  CompanyBadges,
} from './components';

export const Careers = () => (
  <>
    <Hero />
    <Life />
    <Achieve />
    <CurveBackground />
    <CurrentOpenings />
    <CompanyBadges />
  </>
);

export default Careers;
